import {fallbackToolPresentation, isPresentationRecord, type ToolPresentation} from "./toolPresentation";

/** Compatibility metadata for servers predating data-toolPresentation. No tool-specific renderer. */
export function legacyToolPresentation(toolName: string, input: Record<string, unknown>): ToolPresentation {
   const fallback = fallbackToolPresentation(toolName);
   const body = isPresentationRecord(input.body) ? input.body : input;
   if (toolName !== "calls_start" || typeof body.to !== "string" || !body.to.trim() ||
      ["isTestCall", "preRecorded"].some(key => body[key] !== undefined && typeof body[key] !== "boolean")) return fallback;
   const path = (name: string) => body === input ? [name] : ["body", name];
   const test = body.isTestCall === true;
   return {...fallback, kind: "action", icon: "phone", completion: "accepted",
      title: {text: test ? "Test call" : "Outbound call", key: `toolApproval.call.${test ? "testTitle" : "title"}`},
      approveLabel: {text: test ? "Place test call" : "Place call", key: `toolApproval.call.${test ? "approveTest" : "approve"}`},
      description: {text: "Approving will call this number.", key: "toolApproval.call.description"},
      fields: [
         {path: path("to"), label: {text: "Call to", key: "toolApproval.call.recipient"}, format: "phone", emphasis: "primary"},
         ...["scriptId", "name", "preRecorded"].filter(key => Object.hasOwn(body, key)).map(key => ({
            path: path(key), label: {text: key === "scriptId" ? "Script" : key === "name" ? "Call name" : "Call mode",
               key: `toolApproval.call.${key === "scriptId" ? "script" : key === "name" ? "name" : "mode"}`},
            format: key === "scriptId" ? "entity" as const : "text" as const, emphasis: "normal" as const,
            ...(key === "preRecorded" ? {choices: [
               {value: true, label: {text: "Pre-recorded message", key: "toolApproval.call.recorded"}},
               {value: false, label: {text: "Live conversation", key: "toolApproval.call.live"}},
            ]} : {}),
         })),
      ]};
}
